import * as actions from "./actions";
import axios from "axios";
import { values } from "lodash";
import Countries from "assets/countries";
import { setCountryCode } from ".";

export { setCustomer, setCountryCode } from "./actions";

export const setTitle = genderOption => (dispatch, getState) => {
  const state = getState();
  const title = state.customer.title;

  const isGenderTitle = values(genderTitles).includes(title);

  if (!title || isGenderTitle) {
    const _title = genderTitles[genderOption.text.toLowerCase()];
    dispatch(actions.setTitle(_title));
  }
};

export const setName = name => dispatch => {
  if (name.length > 5) {
    const containsTitle = titlePatterns.some(pattern =>
      pattern.regex.some(regex => {
        if (name.search(regex) >= 0) {
          const _name = name.replace(regex, "");
          dispatch(actions.setName(_name));
          dispatch(actions.setTitle(pattern.title));
          return true;
        }
      }),
    );
    if (!containsTitle) {
      dispatch(actions.setName(name));
    }
  } else {
    dispatch(actions.setName(name));
  }
};

export const setIPBasedCountryCode = () => dispatch => {
  axios
    .get("https://ipapi.co/country_calling_code/")
    .then(response => {
      dispatch(
        setCountryCode(
          Object.keys(Countries).find(
            countryCode =>
              Countries[countryCode].dialCode == response.data.slice(1),
          ),
        ),
      );
    })
    .catch(error => {
      dispatch(setCountryCode("PK"));
    });
};

const genderTitles = {
  male: "Mr. ",
  female: "Ms. ",
};

const titlePatterns = [
  {
    regex: [/dr(\s+|[.])+/i, /doctor\s+/i],
    title: "Dr. ",
  },
  {
    regex: [/mrs(\s+|[.])/i, /misses\s+/i, /missus\s+ /i],
    title: "Mrs. ",
  },
  {
    regex: [/engr(\s+|[.])/i, /engineer(\s+|[.])+/i, /engg(\s+|[.])+/i],
    title: "Engr. ",
  },
];
